import { render, staticRenderFns } from "./DashboardECommerce.vue?vue&type=template&id=a8b1bab8"
import script from "./DashboardECommerce.vue?vue&type=script&lang=js"
export * from "./DashboardECommerce.vue?vue&type=script&lang=js"
import style0 from "./DashboardECommerce.vue?vue&type=style&index=0&id=a8b1bab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports